/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_Item_2_ProblemInputs */

const es_home_usecases_item_2_problem = /** @type {(inputs: Home_Usecases_Item_2_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un gerente necesita recordar qué se acordó en un email de hace 3 meses sobre un cambio de alcance.`)
};

const en_home_usecases_item_2_problem = /** @type {(inputs: Home_Usecases_Item_2_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A manager needs to recall what was agreed in an email 3 months ago about a scope change.`)
};

/**
* | output |
* | --- |
* | "A manager needs to recall what was agreed in an email 3 months ago about a scope change." |
*
* @param {Home_Usecases_Item_2_ProblemInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_item_2_problem = /** @type {((inputs?: Home_Usecases_Item_2_ProblemInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_Item_2_ProblemInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_item_2_problem(inputs)
	return en_home_usecases_item_2_problem(inputs)
});
export { home_usecases_item_2_problem as "home.usecases.item_2_problem" }